import React from 'react';
import styled from 'styled-components';
import { RowType } from '../../../../redux/slices/oldBuilder';
import {
  PathDirectionKey,
  QueryType,
} from '../../../../utils/apollo/graphqlSchema';
import { ReroutingEvents } from '../../../../components/Builder/BuilderFields';
import PathDirection from './PathDirection';
import {
  pathAdjustmentsTooltip,
  pathEventsTooltip,
} from '../../../../components/KubitTooltip/globalTooltips';
import SectionHeading from '../../../../components/SectionHeading';
import * as BuilderUI from '../../../../components/Builder/BuilderUI';
import ReportFilter from '../../../../components/Builder/ReportFilter';
import Breakdown from '../../../../components/Builder/Breakdown';
import PathConditions from './PathConditions';
import PathBuilderHeader from './PathBuilderHeader';
import BuilderExecutionDateRange from '../../../../components/Builder/BuilderExecutionDateRange';
import ExecuteReport from '../../../../components/Builder/ExecuteReport';
import useBuilderSelector from '../../../../redux/selectorHooks/useBuilderSelector';
import useShowCloseLlmPrompt from '../../../../components/Builder/LlmPrompt/useShowCloseLlmPrompt';
import LlmPrompt from '../../../../components/Builder/LlmPrompt';

const Container = styled.div`
  display: grid;
  grid-template-columns: 150px 1fr;
  column-gap: 16px;
  align-content: start;
`;

const DirectionContainer = styled.div`
  margin-top: 17px;
`;

const EventsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  width: 100%;
`;

const PathBuilder = () => {
  const pathDirection = useBuilderSelector('direction');
  const directionIsForward = pathDirection === PathDirectionKey.Forward;

  const { showLlmPrompt, handleCloseLlmPrompt } = useShowCloseLlmPrompt();

  return (
    <>
      <PathBuilderHeader />
      {showLlmPrompt && (
        <LlmPrompt queryType={QueryType.Path} onClose={handleCloseLlmPrompt} />
      )}
      <BuilderUI.Part1>
        <SectionHeading heading="Event(s)" tooltipOption={pathEventsTooltip} />
        <Container>
          <DirectionContainer>
            <PathDirection />
          </DirectionContainer>
          <EventsContainer>
            <PathConditions
              rowMeta={{
                rowIndex: directionIsForward ? 0 : 1,
                rowType: RowType.paths,
                pathDirection,
              }}
              label={
                directionIsForward ? 'Starting Event(s)' : 'Ending Event(s)'
              }
            />

            <PathConditions
              rowMeta={{
                rowIndex: directionIsForward ? 1 : 0,
                rowType: RowType.paths,
                pathDirection,
              }}
              label={
                directionIsForward ? 'Ending Event(s)' : 'Starting Event(s)'
              }
            />
          </EventsContainer>
        </Container>
      </BuilderUI.Part1>
      <BuilderUI.Part2>
        <ReportFilter />
        <BuilderUI.HorizontalDivider />
        <Breakdown />
        <BuilderUI.HorizontalDivider />
        <SectionHeading
          heading="Path Adjustment(s)"
          tooltipOption={pathAdjustmentsTooltip}
        />
        <ReroutingEvents
          allowExpand={true}
          allowFold={true}
          allowMerge={true}
        />
        <BuilderUI.HorizontalDivider />
        <BuilderExecutionDateRange />
      </BuilderUI.Part2>
      <ExecuteReport />
    </>
  );
};

export default PathBuilder;
